import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Table,
  Spin,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import {
  materialTypeService,
  measurementTypeService,
  packingTypeService,
  stockClassificationService,
  productForecastService,
} from "_services";
import TabMenu from "./TabMenu";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { StockTypeSecondaryCodeFormatter } from "_helpers/formatters";
let lineIndex = 0;

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [stockType, setStockType] = useState({});
  const [packingTypes, setPackingTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  //const [qualityTypes, setQualityTypes] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [forecast, setForecast] = useState();
  const [materialLines, setMaterialLines] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);

    productForecastService
      .getForecastById(id)
      .then((x) => {
        let data = x.content;
        setForecast(data);
        onFill(data);
        setIsLoading(false);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  }, []);

  useEffect(() => {
    if (forecast?.product?.id) {
      setIsLoading(true);
      materialTypeService
        .getById(forecast?.product?.id)
        .then((x) => {
          let data = x.content;
          setIsLoading(false);
          setStockType(x.content);
          setMaterialLines(x.content.materials);
          if (x.content.stockClass.name === "FINISHED PRODUCT") {
            getRawMaterials(x.content.stockClass);
          }
          onFill(data);
        })
        .catch((errorInfo) => {
          setIsLoading(false);
          message.error(`${errorInfo}`);
        });
      packingTypeService.getSuggestion().then((x) => {
        setPackingTypes(x.content);
      });
      stockClassificationService.getSuggestion().then((x) => {
        setStockClasses(x.content);
      });
      getMeasurements();
    }
  }, [forecast]);

  const getRawMaterials = (classification) => {
    setIsLoading(true);
    materialTypeService
      .search(`?stockClassId=${classification.id}`)
      .then((x) => {
        setIsLoading(false);
        setRawMaterials(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getMeasurements = () => {
    measurementTypeService
      .getSuggestion()
      .then((x) => {
        setMeasurementTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleAddMaterialLine = () => {
    const defaultMeasurementType = measurementTypes.find(
      (item) => item.name === "KG"
    );

    const newLine =
      defaultMeasurementType === null
        ? {}
        : {
            measurementType: defaultMeasurementType.id,
          };
    newLine.key = lineIndex;
    const lines = [...materialLines, newLine];
    setMaterialLines(lines);
    lineIndex += 1;
  };

  const handleRemoveMaterialLine = (line) => {
    const lines = [...materialLines];
    if (lines.includes(line)) {
      lines.splice(lines.indexOf(line), 1);
      setMaterialLines(lines);
    }
  };

  const handleSaveMaterialLine = (e, key) => {
    e.persist();
    const target = getRowBykey(key) || {};
    if (
      !target.materialType ||
      !target.quantityPerUnit ||
      !target.conversionRatio ||
      !target.wastagePercentage ||
      !target.measurementType
    ) {
      message.error("Please complete the raw material line details.");
      e.target.focus();
      return;
    }
    handleAddMaterialLine();
  };

  const getRowBykey = (key, newData) => {
    return (materialLines || newData).filter((item) => item.key === key)[0];
  };

  const handleFieldChange = (value, fieldName, key) => {
    const lines = [...materialLines];
    const newMaterialLines = lines.map((line) => {
      const newLine = Object.assign({}, line);
      if (newLine.key === key) {
        if (fieldName === "materialType") {
          newLine[fieldName] = rawMaterials.find((item) => item.id === value);
          return newLine;
        } else {
          newLine[fieldName] = value;
          return newLine;
        }
      }
      return newLine;
    });
    setMaterialLines(newMaterialLines);
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "HS Code",
      dataIndex: ["materialType", "code"],
      key: "materialType",
    });
    columns.push({
      title: "Company Code",
      dataIndex: ["materialType", "secondaryCode"],
      key: "secondaryCode",
      //width: "20%",
      render: (text, record) => (
        <Tooltip title={text}>{text?.substring(0, 8)}</Tooltip>
      ),
    });
    columns.push({
      title: "Description",
      dataIndex: ["materialType", "name"],
      key: "materialType",
    });
    columns.push({
      title: "Quantity Per Unit",
      dataIndex: "quantityPerUnit",
      key: "quantityPerUnit",
    });
    columns.push({
      title: "Conversion Ratio",
      dataIndex: "conversionRatio",
      key: "conversionRatio",
    });
    columns.push({
      title: "Wastage Percentage",
      dataIndex: "wastagePercentage",
      key: "wastagePercentage",
    });
    columns.push({
      title: "UOM",
      dataIndex: ["uom", "name"],
      key: "uom",
    });

    return columns;
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/material-types");
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom">Forecasts</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>
                {" "}
                Summery of <b> {forecast?.product.name}</b>{" "}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        //Add buttons in the page header
        extra={
          <>
            <Button>PDF Download</Button>
            <Button>Excel Download</Button>
          </>
        }
      >
        <Page inner>
          <Spin tip="Loading..." spinning={isLoading}>
            {/* <TabMenu menu="summary" id={id} /> */}
            <Form
              form={form}
              name="form-create"
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={4}>
                  <Form.Item
                    name={["product", "code"]}
                    label="HS Code"
                    rules={[{ required: true, message: "HS Code is required" }]}
                  >
                    <Input placeholder="HS Code" readOnly={true} />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name={["product", "secondaryCode"]}
                    label="Product Code"
                  >
                    <Input readOnly={true} placeholder="Customer Code" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item name="forecastQuantity" label="Forecast Quantity">
                    <Input readOnly={true} placeholder="Name" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item name={["totalCost"]} label="Total Cost">
                    <Input readOnly={true} placeholder="Customer Code" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item name={["currency", "name"]} label="Currency">
                    <Input readOnly={true} placeholder="Customer Code" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item name={["exchangeRate"]} label="Exchange Rate">
                    <Input readOnly={true} placeholder="Customer Code" />
                  </Form.Item>
                </Col>

                <Col span={6}></Col>
              </Row>

              <Col span={6}></Col>
              <Col span={6}></Col>

              {stockType?.materials?.length > 0 && (
                <Table
                  bordered
                  pagination={false}
                  columns={getLineColumns()}
                  dataSource={stockType.materials}
                  size="small"
                />
              )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
